<script setup>
import {
  IonButtons,
  IonContent,
  IonGrid,
  IonHeader,
  IonPage,
  IonToolbar,
  IonRow,
  IonCol,
  IonButton,
  IonIcon,
  modalController,
} from "@ionic/vue";
import Header from "@/components/Header";
import Collapsible from "@/components/Collapsible";
import QualitySmile from "./QualitySmile";

const showQualitySmile = async () => {
  const modal = await modalController.create({
    component: QualitySmile,
    componentProps: {
      from: "chat",
    },
  });
  return modal.present();
};
</script>

<template>
  <ion-page>
    <ion-header class="ion-no-border">
      <ion-toolbar>
        <ion-buttons slot="start">
          <back-button
            :defaultHref="{ name: 'home' }"
            :icon="require('@lib/assets/icons/icon_zurueck.svg')"
            text="">
          </back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content ref="content" class="ion-padding">
      <ion-grid fixed>
        <Header
          class="u-bg-grey"
          headline="Ihr schneller Weg zu Kostenzusagen und Prüfungen von
            Behandlungsplänen"
          :image="
            require('@/assets/img/slider/links/behandlungsplan/zahn-behandlungsplan-einreichen.svg')
          "
          @openChat="
            $router.push({
              name: 'home',
              params: {
                name: 'toothTreatmentplan',
                area: 'head-front',
                from: 'behandlungsplan-pruefen',
              },
            })
          " />
        <p class="ion-padding-top ion-hide-lg-up">
          <b
            >Ihr schneller Weg zu Kostenzusagen und Prüfungen von
            Behandlungsplänen</b
          >
        </p>
        <p>
          Reichen Sie Ihre Behandlungspläne/<wbr />Kostenvoranschläge gleich
          hier zur Prüfung durch die ARAG ein.
        </p>
        <p>
          Wenn Sie bereits eine Zusage der ARAG haben, prüft der
          Patientenservice von Quality Smile gerne Ihren Behandlungsplan
          fachlich und unterstützt Sie auf Wunsch auch bei der Suche einer
          passenden Zahnarztpraxis.
        </p>
        <div class="c-cta">
          <ion-button
            @click="
              $router.push({
                name: 'home',
                params: {
                  name: 'toothTreatmentplan',
                  area: 'head-front',
                  from: 'behandlungsplan-pruefen',
                },
              })
            "
            class="mt-5"
            >Behandlungsplan prüfen&nbsp;
            <ion-icon
              :src="require('@lib/assets/icons/roodie-white.svg')"
              slot="end"></ion-icon>
          </ion-button>
        </div>
        <collapsible>
          <template v-slot:title
            ><ion-row class="ion-align-items-center">
              <ion-col size="auto">
                <ion-icon
                  :src="require('@lib/assets/icons/icon_gesetzliche.svg')"
                  size="large"></ion-icon>
              </ion-col>
              <ion-col>
                <b>Einholung einer Kostenfreigabe</b>
              </ion-col>
            </ion-row></template
          >
          <div class="ion-margin-bottom">
            <p>
              <ion-row>
                <ion-col size="auto">
                  <ion-icon
                    size="large"
                    :src="
                      require('@lib/assets/icons/icon_dokument_hochladen.svg')
                    " />
                </ion-col>
                <ion-col>
                  Dazu können Sie das Dokument aus einem Ordner hochladen oder
                  machen Sie einfach ein Foto davon.
                </ion-col>
              </ion-row>
            </p>
            <p>
              <ion-row>
                <ion-col size="auto">
                  <ion-icon
                    size="large"
                    :src="require('@lib/assets/icons/icon_befund_u_co.svg')" />
                </ion-col>
                <ion-col>
                  Das Dokument wird in Ihrem Roodie.Safe unter “Befunde & Co”
                  für Sie abgelegt, damit Sie es jederzeit griffbereit haben.
                  sind.
                </ion-col>
              </ion-row>
            </p>
            <p>
              <ion-row>
                <ion-col size="auto">
                  <ion-icon
                    size="large"
                    :src="require('@lib/assets/icons/icon_artzwechsel.svg')" />
                </ion-col>
                <ion-col>
                  Die ARAG Gesundheitsassistenten prüfen für Sie, ob die
                  Behandlungskosten in Ihrem Versicherungsvertrag abgedeckt
                  sind.
                </ion-col>
              </ion-row>
            </p>
            <p>
              <ion-row>
                <ion-col size="auto">
                  <ion-icon
                    size="large"
                    :src="require('@lib/assets/icons/icon_telefon.svg')" />
                </ion-col>
                <ion-col>
                  Sie erhalten direkt von Roodie eine Nachricht über die
                  Kostenzusage der ARAG oder falls von Ihnen gewünscht, werden
                  Sie von
                  <a href="#" @click.prevent="showQualitySmile()"
                    >Quality Smile</a
                  >, dem Zahnlaborpartner der ARAG, anschließend kontaktiert.
                </ion-col>
              </ion-row>
            </p>
            <p>
              <ion-row>
                <ion-col size="auto">
                  <ion-icon
                    size="large"
                    :src="
                      require('@lib/assets/icons/icon_verlaufskontrolle.svg')
                    " />
                </ion-col>
                <ion-col>
                  Oder ein ARAG Gesundheitsassistent meldet sich, um Ihnen
                  alternative Lösungen aufzuzeigen und bei der Organisation
                  Ihrer Behandlung behilflich zu sein.
                </ion-col>
              </ion-row>
            </p>
          </div>
        </collapsible>
        <collapsible>
          <template v-slot:title
            ><ion-row class="ion-align-items-center">
              <ion-col size="auto">
                <ion-icon
                  :src="require('@lib/assets/icons/icon_fachliche.svg')"
                  size="large"></ion-icon>
              </ion-col>
              <ion-col>
                <b>Unterstützung bei Zweitmeinung und Zahnarztsuche</b>
              </ion-col>
            </ion-row></template
          >
          <div class="ion-margin-bottom">
            <p>
              <ion-row>
                <ion-col size="auto">
                  <ion-icon
                    size="large"
                    :src="
                      require('@lib/assets/icons/icon_verlaufskontrolle.svg')
                    " />
                </ion-col>
                <ion-col>
                  Mit Ihrer Zustimmung erhält der Patientenservice von
                  <a href="#" @click.prevent="showQualitySmile()"
                    >Quality Smile</a
                  >
                  Ihren Roodie.Check und Ihren Behandlungsplan, um Sie zu
                  kontaktieren und bei Ihrem Anliegen zu unterstützen.
                </ion-col>
              </ion-row>
            </p>
            <p>
              <ion-row>
                <ion-col size="auto">
                  <ion-icon
                    size="large"
                    :src="require('@lib/assets/icons/icon_artzwechsel.svg')" />
                </ion-col>
                <ion-col>
                  Der Patientenservice prüft Ihren Behandlungsplan und erstellt
                  auf Wunsch auch einen Kostenvoranschlag für Sie.
                </ion-col>
              </ion-row>
            </p>
            <p>
              <ion-row>
                <ion-col size="auto">
                  <ion-icon
                    size="large"
                    :src="
                      require('@lib/assets/icons/icon_weiter_behandlung.svg')
                    " />
                </ion-col>
                <ion-col>
                  Auf Wunsch empfiehlt Ihnen Quality Smile auch passende
                  Zahnarztpraxen aus deren Netzwerk. Sie können dann direkt mit
                  der Praxis Kontakt aufnehmen, um einen Termin zu vereinbaren
                  oder das Patientenservice unterstützt Sie auch dabei.
                </ion-col>
              </ion-row>
            </p>
            <p>Das Service ist für Sie kostenlos.</p>
          </div>
        </collapsible>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>
